/**
* @file 运营中心-旅游包车订单
* */
<template>
  <div id="order">
    <custom-table
      :has-organization="false"
      ref="customTable"
      :customOptions="customOptions"
      :columns="columns"
      labelWidth="135"
      style="height: 100%"
      :columnsSettingShow="true"
    >
      <template slot="table-operation">
        <el-table-column label="操作" minWidth="180" fixed="right" align="center">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="showOrderDetail(row)">详情</el-button>
            <el-button type="text" @click="actionFn({ type: 'assign', row: row })">指派</el-button>
            <el-button type="text" @click="actionFn({ type: 'look', row: row })">附近司机</el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'created'">{{
          row.created | filterTime
        }}</template>
        <template
          v-else-if="
            [
              'latestDepartureTime',
              'created',
              'finishTime',
            ].includes(item.prop)
          "
        >
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else-if="item.prop == 'orderNo'">
          <span class="order-no-link" @click="showOrderDetail(row)" @dblclick="$utils.dblclickCopy">{{ row.orderNo }}</span>
        </template>
        <template v-else-if="item.prop == 'partnerOrderId'">
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
        <template v-else-if="item.prop == 'earliestDepartureTime'">
          <span>{{ row.earliestDepartureTime | filterTime }}</span>
          <div style="color: #999">{{ row.latestDepartureTime | filterTime }}</div>
        </template>
        <template v-else-if="item.prop == 'poolType'">
          <el-tag :type="row.poolType == 1 ? 'primary' : 'success'" size="small">{{ row.poolType == 1 ? '独享' : '拼车' }}</el-tag>
        </template>
        <template v-else-if="item.prop === 'startCity'">
          <div>{{ row.startCity }} - {{ row.endCity }}</div>
          <el-tag :type="row.cityType == 1 ? 'warning' : 'success'" size="small">{{ row.cityType == 1 ? '城际' : '市内' }}线路</el-tag>
        </template>
        <template v-else-if="item.prop === 'startPointName'">
          <div>{{ row.startPointName }}</div>
          <div style="color: #999">{{ row.startPointAddress }}</div>
        </template>
        <template v-else-if="item.prop === 'endPointName'">
          <div>{{ row.endPointName }}</div>
          <div style="color: #999">{{ row.endPointAddress }}</div>
        </template>
        <template v-else-if="item.prop == 'channelAlias'">
          {{ row.channelAlias | filterConst("HITCHHIKINGCHANNEL") }}
        </template>

        <template v-else-if="item.prop == 'vehicleSeat'"
          >{{ row.vehicleSeat }}座</template
        >
        <template v-else-if="item.prop == 'distance'"> 
          <span >{{ row.distance }} km</span>
          <div style="color: #2B77FF">{{ ((row.commissionAmount / row.distance) || 0).toFixed(2) }} 元/公里</div>
        </template>
        <template v-else-if="item.prop == 'realPhoneSuffix'">用户{{ row.realPhoneSuffix }} / {{ row.passengerNum
          }}人</template>

        <template v-else-if="item.prop == 'cancelFee'">
          <span v-if="row.cancelFee">
            <span class="util-money">¥{{ row.cancelFee || 0 }}</span
            ><span v-if="row.cancelRatio">({{ row.cancelRatio }}取消费率)</span>
          </span>
          <span v-else>-</span>
        </template>

        <template v-else-if="item.prop == 'commissionAmount'">
          <span class="util-money"> ¥{{ row.commissionAmount || 0 }} </span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-drawer
      :visible.sync="show"
      destroy-on-close
      :close-on-click-modal="false"
      :before-close="handClose"
    >
      <hitchRideOrderDispatchMap
        :rowData="rowData"
        v-if="show"
      ></hitchRideOrderDispatchMap>
    </el-drawer>
    <!-- 指派司机 -->
    <el-dialog
      title="订单指派"
      :visible.sync="dialogTableVisible"
      width="1100px"
      :close-on-click-modal="false"
      @close="dialogClose"
    >
      <p class="dialog_tips">请输入车辆号牌、司机姓名搜索车辆后，再指派订单</p>
      <custom-table
        :has-organization="false"
        ref="driverTable"
        :customOptions="driverOptions"
        :columns="driverColumns"
        :refreshShow="false"
        :paging="false"
        labelWidth="135"
        style="height: 65vh"
        v-if="dialogTableVisible"
      >
        <template slot-scope="{ item, row }">
          <template v-if="item.prop == 'commissionAmount'">
            <span class="util-money"> ¥{{ row.commissionAmount || 0 }} </span>
          </template>
          <template v-else-if="item.prop == 'licenseNo'">
            <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(row.licenseNo) }}</span>
            <span v-else>-</span>
          </template>
          <template v-else-if="item.prop == 'driverName'">
            <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
          </template>
          <template v-else-if="item.prop == 'driverPhone'">
            <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
          </template>

          <template v-else>{{
            row[item.prop] ? row[item.prop] : "-"
          }}</template>
        </template>
        <template slot="table-operation">
          <el-table-column
            label="操作"
            fixed="right"
          >
            <div slot-scope="{ row }" class="custom-action">
              <el-button
                type="text"
                @click="assignFn(row)"
                >指派</el-button
              >
            </div>
          </el-table-column>
        </template>
      </custom-table>
    </el-dialog>

    <el-dialog
      class="result-dialog"
      :visible.sync="resultDialog"
      :show-close="false"
      :close-on-click-modal="false"
      width="358px"
    >
      <div class="content">
        <img src="../../../assets/img/waitting.png" alt="" />
        <div class="time">正在全力抢单({{ count }}秒)</div>
        <div class="tips">请勿关闭当前页面</div>
      </div>
      <el-button class="btn" type="primary" :disabled="count < 10" @click="waitView">稍后查看抢单结果</el-button>
    </el-dialog>
    <!-- 订单详情抽屉 -->
    <order-detail-drawer :show.sync="orderDetailVisible" :order="currentOrderDetail" />
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import OrderDetailDrawer from "@/components/orderDetailDrawer/orderDetailDrawer.vue";
export default {
  name: "hitchRideOrderDispatch",
  components: {
    hitchRideOrderDispatchMap: () =>
      import("./components/hitchRideOrderDispatchMap.vue"),
    OrderDetailDrawer
  },
  data() {
    return {
      // 订单详情抽屉
      orderDetailVisible: false,
      currentOrderDetail: {},
      
      tabAction: "all",
      loading: false,
      refundFee: null,
      refundState: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/order/hitchRide/dispatch/list",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "select",
            field: "cityType",
            name: "顺风车类型",
            value: "",
            option: this.$const.HITCHHIKINGTYPE,
          },
          {
            type: "select",
            field: "poolType",
            name: "订单类型",
            value: "",
            option: this.$const.POOLTYPE,
          },
          { type: "input", field: "startCity", name: "出发地城市", value: "" },
          { type: "input", field: "endCity", name: "目的地城市", value: "" },
          // {
          //   type: "datetime",
          //   field: "EarliestDepartureTime",
          //   dateProp: {start: "startEarliestDepartureTime", end: "endEarliestDepartureTime"},
          //   name: "最早出发时间",
          //   value: []
          // },
          // {
          //   type: "datetime",
          //   field: "LatestDepartureTime",
          //   dateProp: {start: "startLatestDepartureTime", end: "endLatestDepartureTime"},
          //   name: "最晚出发时间",
          //   value: []
          // },
          // {
          //   type: "datetime",
          //   field: "finishTime",
          //   dateProp: {start: "startFinishTime", end: "endFinishTime"},
          //   name: "完成时间",
          //   value: []
          // },
        ],
      },
      // 表头
      columns: [
        { prop: "orderNo", label: "订单号", minWidth: 190 },
        { prop: "startCity", label: "城市/线路", minWidth: 120 },
        { prop: "startPointName", label: "上车位置", minWidth: 200 },
        { prop: "endPointName", label: "下车位置", minWidth: 200 },
        { prop: "earliestDepartureTime", label: "出发时间", minWidth: 130 },
        { prop: "realPhoneSuffix", label: "乘客", minWidth: 110 },
        { prop: "poolType", label: "是否拼车", minWidth: 80 },
        { prop: "commissionAmount", label: "订单金额", minWidth: 100 },
        { prop: "distance", label: "计价里程", minWidth: 100 },
        { prop: "partnerOrderId", label: "三方订单号", minWidth: 120 },
      ],
      dialogTableVisible: false,
      // 配置项
      driverOptions: {
        firstNotRequest: true,
        // 请求的列表url
        url: "/api/v1/manage/order/hitchRide/dispatch/vehicle",
        // 请求的参数列表
        params: {
          hitchRideOrderId: ''
        },
        search: [
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "driverPhone", name: "司机电话", value: "" },
        ],
      },
      // 表头
      driverColumns: [
        { prop: "licenseNo", label: "车辆号牌", minWidth: 190 },
        { prop: "vehicleSeat", label: "座位数", minWidth: 200 },
        { prop: "driverName", label: "司机信息", minWidth: 200 },
        { prop: "driverPhone", label: "联系电话", minWidth: 130 },
        { prop: "commissionAmount", label: "该笔订单司机收益", minWidth: 130 },
      ],
      // 状态
      status: null,
      show: false,
      showCancel: false,
      rowData: {},
      resultDialog: false,
      count: 1,
      timer: null
    };
  },
  computed: {
    ...mapGetters({
      messageGetter: "messageGetter",
    }),
  },
  watch: {
    // 监听消息
    messageGetter(val) {
      switch (val.msg) {
        case "OrderHitchRidePlatformAssign":
          if(val.data == this.mixinUserInfo.id){
            this.$message.success("订单指派成功");
            this.waitView()
          }
          break
        case "OrderHitchRideCancel":
          if(val.data == this.mixinUserInfo.id){
            this.$message.error("抢单失败！");
            this.waitView()
          }
          break
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    dialogClose() {
      this.driverOptions.firstNotRequest = true;
      this.dialogTableVisible = false;
    },
    actionFn({ type, row }) {
      switch (type) {
        case "look":
          this.rowData = row;
          this.show = true;
          break;
        case "cancel":
          this.rowData = row;
          this.showCancel = true;
          break;
        case "assign":
          this.driverOptions.params.hitchRideOrderId = row.id;
          this.rowData = { ...row };
          this.dialogTableVisible = true;
          this.$nextTick(() => {
            this.driverOptions.firstNotRequest = false;
          });
          break;
      }
    },
    /**
     * 状态改变
     */

    handClose() {
      this.rowData = {};
      this.show = false;
      this.showCancel = false;
    },
    async assignFn(row){
      const url = "/api/v1/manage/order/hitchRide/assign"
      const params = {
        hitchRideOrderId: this.rowData.id,
        vehicleId: row.vehicleId,
        driverId: row.driverId
      }
      const {code} = await this.$axios.post(url, params)
      if(code === 1){
        this.dialogTableVisible = false;
        this.resultDialog = true;
        this.timer = setInterval(() => {
          this.count++;
        }, 1000);
      } else if([90000, 99999].includes(code)){
        this.dialogTableVisible = false;
        this.$refs.customTable.listFn()
      } else {
        this.$refs.driverTable.listFn()
      }
    },
    waitView(){
      this.resultDialog = false;
      this.$refs.customTable.listFn()
      clearInterval(this.timer)
      this.count = 1
    },
    /**
     * 显示订单详情
     */
    showOrderDetail(row) {
      this.currentOrderDetail = { ...row };
      this.orderDetailVisible = true;
    },
  },
  created() {},
};
</script>

<style scoped lang="less">
#order {
  .order-no-link {
    color: #2B77FF;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  .dialog_tips {
    color: red;
    margin: 10px 0 5px;
  }
  .result-dialog {
    .content {
      font-family: Source Han Sans SC, Source Han Sans SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      text-align: center;
      width: 100%;
      .time {
        margin: 10px 0;
      }
      .tips {
        font-size: 14px;
      }
    }
    .btn {
      width: 100%;
      margin-top: 16px;
    }

    /deep/ .el-dialog__body {
      padding: 0 20px 20px !important;
    }
  }
  /deep/ .el-drawer {
    width: 70% !important;
    overflow-x: hidden;
  }

  .el-radio-group {
    .el-radio-button__inner {
      /*border-radius: 0;*/
    }
  }
}
</style>
